import { tabAccessControl } from "../../../_helpers/access-control";

let PointOfSalesTab = [
  {
    text: "New Transaction",
    path: `/point-of-sale/create`,
    applicationFeatureCode: "PointOfSale",
  },
  {
    text: "Transaction History",
    path: `/point-of-sale-history`,
    applicationFeatureCode: "PointOfSale",
  },
];


function GetIndexByTabName(tabName) {
  return tabAccessControl(PointOfSalesTab).findIndex((x) => x.text == tabName);
}

export { PointOfSalesTab, GetIndexByTabName };